import { render } from "./ub-ani.vue?vue&type=template&id=c6deeda8&scoped=true"
import script from "./ub-ani.vue?vue&type=script&lang=js"
export * from "./ub-ani.vue?vue&type=script&lang=js"

import "./ub-ani.vue?vue&type=style&index=0&id=c6deeda8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6deeda8"]])

export default __exports__